/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalAnswerItemDataRequestSchema = z.object({
	questionId: z.string().uuid(),
	answer: z.string().nullable().optional(),
	optionId: z.string().uuid().nullable().optional(),
})

export type AdditionalAnswerItemDataRequestSchema = z.infer<typeof additionalAnswerItemDataRequestSchema>
